import { mergeMap, catchError, switchMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of, concat } from 'rxjs';
import { ModalService } from 'ui-components/services/modal-service';
import Global from '../../global-selectors';
import CombineCustomersModal from '../../../pages/customers-page/modals/combine-customers-modal';
import { CombineCustomersConfirmationModal } from '../../../pages/customers-page/modals/combine-customers-confirmation-modal';
import * as Actions from './customers.combine.actions';
import * as CustomerActions from '../customers.actions';
import * as NavActions from '../nav/customers.nav.actions';
import * as SelectedCustomersActions from '../selected-customers/customers.selected-customers.actions';
import * as Api from '../customers.api';

let modalId;

const reorderCustomers = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const prepareToOpenCombineCustomersModal = (action$) => {
  return action$.pipe(
    ofType(Actions.PREPARE_COMBINE_CUSTOMERS_MODAL_OPEN),
    mergeMap(() => {
      modalId = ModalService.launchModal({
        component: CombineCustomersModal,
        height: '100%',
        maxHeight: '100%',
      });
      return of(Actions.openCombineCustomersModal(modalId));
    }),
  );
};

export const prepareToOpenCombineCustomersConfirmationModal = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.PREPARE_COMBINE_CUSTOMERS_CONFIRMATION_MODAL_OPEN),
    mergeMap(() => {
      const state = getState();
      const combineCustomersModalId = Global.selectCustomersCombineCombineCustomersModalId(state);
      ModalService.closeModalById(combineCustomersModalId);
      modalId = ModalService.launchModal({
        component: CombineCustomersConfirmationModal,
        height: '100%',
        maxHeight: '100%',
      });
      return of(Actions.openCombineCustomersConfirmationModal(modalId));
    }),
  );
};

export const combineCustomers = (action$, { getState }) => {
  let confirmCustomersModalId = '';
  return action$.pipe(
    ofType(Actions.INITIATE_COMBINE_CUSTOMERS),
    switchMap((action) => {
      const state = getState();
      confirmCustomersModalId = Global.selectCustomersCombineConfirmCustomersModalId(state);
      return Api.postCombinePayload(action.selectedCustomerIds).pipe(
        mergeMap(() => {
          ModalService.closeModalById(confirmCustomersModalId);

          return concat(of(CustomerActions.requestGetCustomers()), of(NavActions.clearSearchInput()));
        }),
      );
    }),
    catchError(() => {
      ModalService.closeModalById(confirmCustomersModalId);
      return EMPTY;
    }),
  );
};

export const closeCombineCustomersConfirmationModal = (action$) => {
  return action$.pipe(
    ofType(Actions.COMBINE_CUSTOMERS_CONFIRMATION_MODAL_CLOSED),
    mergeMap(() => {
      return of(Actions.prepareToOpenCombineCustomersModal());
    }),
  );
};

export const reorderSelectedCustomers = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.REORDER_SELECTED_CUSTOMERS),
    mergeMap((action) => {
      const state = getState();
      const { sourceIndex, destinationIndex } = action;
      const selectedCustomers = Global.selectSelectedCustomersIds(state);

      const customers = reorderCustomers(selectedCustomers, sourceIndex, destinationIndex);

      return of(SelectedCustomersActions.setSelectedCustomers(customers));
    }),
  );
};
